import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
const roundToNearest = (x: number, v: number) => Math.ceil(x / v) * v

const secColor = '#fff'
const mainColor = '#202346'
const StyledMarker = styled.g`
  rect,
  circle {
    cursor: pointer;
  }
  path,
  text,
  polygon {
    pointer-events: none;
    user-select: none;
  }
`
export const Marker = ({
  x,
  y,
  position = 'middle',
  text
}: {
  x: number
  y: number
  position: string
  text: string | JSX.Element
}) => {
  const TEXT = useRef<SVGTextElement>(null)
  const [rectsize, setRectSize] = useState({ width: 250, height: 40 })
  const [show, setShow] = useState(true)
  useEffect(() => {
    if (!TEXT.current) return
    setRectSize({
      ...rectsize,
      width: roundToNearest(TEXT.current.getBBox().width, 20) + 20
    })
  }, [TEXT.current])
  let rectwidth = rectsize.width + rectsize.height * 0.6
  return (
    <StyledMarker
      className='Marker'
      transform={`translate(${x},${y - rectsize.height * 1.5})`}
    >
      <defs>
        <marker
          id='triangle'
          viewBox='0 0 10 10'
          refX='1'
          refY='5'
          markerUnits='strokeWidth'
          markerWidth='5'
          markerHeight='5'
          orient='auto'
        >
          <path d='M 0 0 L 10 5 L 0 10 z' fill={mainColor} />
        </marker>
      </defs>
      <circle
        cx={0}
        cy={rectsize.height * 1.5}
        r={6}
        fill={mainColor}
        onClick={() => setShow(true)}
      />
      {show && (
        <>
          <g
            filter={'drop-shadow(0px 0px 2px rgb(0 0 0 / 0.4))'}
            transform={`translate(${
              position === 'right'
                ? rectsize.width / 2
                : position === 'left'
                ? -rectsize.width / 2
                : 0
            },0)`}
          >
            {rectwidth >= 0 && (
              <rect
                x={-rectsize.width / 2 - 1}
                width={rectwidth}
                height={rectsize.height}
                fill={mainColor}
                onClick={() => setShow(false)}
              />
            )}

            <MarkerText fill={secColor} y={25} textAnchor='middle' ref={TEXT}>
              {text}
            </MarkerText>

            <polygon
              transform={`translate(${rectsize.width / 2},${13})scale(.25)`}
              points='55.657 5.657 50 0 27.829 22.172 5.657 0 0 5.657 22.172 27.829 0 50 5.657 55.657 27.829 33.485 50 55.657 55.657 50 33.485 27.829 55.657 5.657'
              fill={secColor}
            />
          </g>{' '}
          <line
            y1={rectsize.height - 1}
            y2={rectsize.height * 1.5}
            stroke={mainColor}
            strokeWidth='2'
            markerEnd='url(#triangle)'
          />
        </>
      )}
    </StyledMarker>
  )
}

const MarkerText = styled.text`
  font-size: 15px;
`
